import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CustomCart } from '@cart/const';
import { CartTotalsListItemComponent } from './cart-totals-list-item';

@Component({
  selector: 'sd-cart-totals-list',
  imports: [CartTotalsListItemComponent],
  templateUrl: './cart-totals-list.component.html',
  styleUrls: ['./cart-totals-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CartTotalsListComponent {
  protected readonly cart = input.required<CustomCart>();
}
